import Heading8 from 'components/Heading/Heading8'
import YouTube from 'react-youtube';

const WidgetVideo = ({
  className = "bg-neutral-100 dark:bg-neutral-800",
  categories,
  height,
  width,
  podcast,
}) => {
  const opts = {
    height: height,
    width: width,
    playerVars: {
      // https://developers.google.com/youtube/player_parameters
      autoplay: 0,
    },
  };

  return (
    // <div
    //   className={`nc-WidgetCategories overflow-hidden ${className}`}
    // >
      <div className="flow-root">
        {/* <div className="flex flex-col divide-y divide-neutral-200 dark:divide-neutral-700"> */}
          {/* <div className="video-box"> */}
              {/* <button style={{marginBottom:'20px'}}>Strefa oglądania i czytania</button> */}
            <div className='header-desktop' style={{paddingBottom:'15px', maxWidth:"339px", paddingTop:'15px'}}><Heading8>Gość Poranny</Heading8></div>
            {/* <h3 style={{fontSize:"24px", fontWeight:'bold', fontFamily:"Redaction"}}>GOŚĆ PORANNY</h3> */}
            <video className="video-box" poster="https://respublica.publit.io/file/Timeline-1-1-L.jpg" controls src="https://respublica.publit.io/file/h_480/PawełKukiz.mp4" opts={opts}></video>
          {/* </div> */}
        </div>
  );
};

export default WidgetVideo;